import React from 'react';
import PrivacyPolicyPage from './PrivacyPolicyPage';

const GiftPlannerPolicies = () => {
  return (
    <PrivacyPolicyPage
      title='Gift Planner Privacy Policy'
      intro={[
        'Gift Planner is provided by Kadjo Benjamin Anoh at no cost and is intended for use as-is. This Privacy Policy explains how information is handled when you use the app.',
      ]}
      sections={[
        {
          title: 'Information Collection and Use',
          paragraphs: [
            'For a better experience while using the service, the app may request access to your photos. Information requested by the app is used to provide the core features of the service.',
          ],
        },
        {
          title: 'Security',
          paragraphs: [
            'I value your trust in providing your information, and I use commercially acceptable means of protecting it. However, no method of electronic storage or transmission is 100% secure and reliable, and I cannot guarantee absolute security.',
          ],
        },
      ]}
      effectiveDate='2021-05-22'
      contactEmail='benjaminanoh@gmail.com'
    />
  );
};

export default GiftPlannerPolicies;
